RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const Action = RivalIQ.views.LayoutView.extend({
        className: 'action',

        regions: {
            action: '.action-region'
        },

        template: function (data) {

            const template = _.template($.tagHtml('div', {
                class: 'action-region'
            }));
            return template(data);
        },

        loadData: function (callback) {

            const me = this;
            const model = me.model;
            const conditions = model.get('conditions');

            if (!_.isFunction(conditions)) {
                return callback();
            }

            $.when(conditions())
                .done(function () {

                    me.data = arguments;
                })
                .always(callback);
        },

        onRenderLoaded: function () {

            const me = this;
            const model = me.model;
            const Cls = me.getOption('class');
            let config = (model.get('config') || {});

            if (_.isFunction(config)) {

                config = config.apply(null, me.data);
            }

            const options = (_.isFunction(Cls.getItemViewOptionsFromConfig) ?
                Cls.getItemViewOptionsFromConfig(config, model) : config);

            const view = new Cls(_.extend({
                model: model
            }, options));

            me.action.show(view);
        },

        onChildviewEdit: function () {
            const me = this;
            me.trigger('edit');
        },

        onChildviewToolbarAction: function (child, attrs, name) {
            const me = this;
            me.trigger('action', attrs, name);
        }
    });

    const Actions = Marionette.CollectionView.extend({
        className: 'actions',

        childView: Action,
        childViewEventPrefix: 'actions',

        getActionView: function (item) {
            let Cls = null;
            const config = item.get('config');

            if (config && config.view) {

                Cls = config.view;
            }

            if (Cls) {
                return Cls;
            }

            // NOTE if the configuration does not specify a view class already
            // then we should look to see if we can generate it via the type
            switch (item.get('type')) {
                case 'button':
                    return views.ToolbarButton;
                case 'buttonGroup':
                    return views.ButtonGroup;
                case 'editButton':
                    return views.ToolbarEdit;
                case 'dropdown':
                    return views.Dropdown;
                case 'radio':
                    return views.RadioButton;
                case 'checkbox':
                    return views.Checkbox;
                default:
                    throw new Error(`unknown item type ${item.get('type')}`);
            }
        },

        childViewOptions: function (item) {

            const me = this;
            return {
                class: me.getActionView(item),
                model: item
            };
        }
    });

    const Toolbar = views.Toolbar = Marionette.LayoutView.extend({
        regions: {
            left: '.toolbar-menu-group.pull-left',
            right: '.toolbar-menu-group.pull-right'
        },

        className: 'btn-toolbar',
        template: '#shellToolbarTemplate',

        childViewEventPrefix: 'toolbar',

        onBeforeShow: function () {

            const me = this;
            const left = [];
            const right = [];

            me.collection.each(function (action) {
                (action.get('menu') === 'left' ? left : right).push(action);
            });

            me.showActions(left, me.left);
            me.showActions(right, me.right);
        },

        showActions: function (items, region) {

            const me = this;

            const view = new Actions({
                collection: new Backbone.Collection(items)
            });

            me.listenTo(view, 'actions:action', me.onToolbarAction);
            me.listenTo(view, 'item:action', me.onToolbarAction);

            region.show(view);
        },

        addActions: function (items, region) {

            const me = this;

            const collection = _.get(me, [
                region || 'right',
                'currentView',
                'collection'
            ].join('.'));

            if (collection) {

                collection.add(items);
            }
        },

        onToolbarAction: function (view, event, name) {

            const me = this;
            name = name || event.name;
            const data = _.extend({
                view: view
            }, event);
            me.trigger('toolbar:action', data);
            me.triggerMethod(`toolbar:action:${name}`, data);
        }
    });

    /**
     * Creates a toolbar view from configuration
     * @param config
     * @returns {views.Toolbar}
     */
    Toolbar.createFromConfig = function (config, template, state) {

        let items = [];
        let attributes = config;

        if (_.isArray(config.items)) {

            items = config.items;
            attributes = _.reduce(config.items, function (memo, action) {

                memo[action.type] = action.config;
                return memo;
            }, {});
        } else {

            items = _.map(config, function (itemConfig, itemType) {

                return {
                    type: itemType,
                    config: itemConfig
                };
            });
        }

        const options = {
            model: new Backbone.Model(_.defaults(attributes || {}, state)),
            collection: new App.collections.ToolbarItems(items)
        };

        if (template) {

            options.template = template;
        }

        _.extend(options, _.pick(config, 'className', 'id'));

        const result = new Toolbar(options);

        return result;
    };

});
